export const environment = {
  orgId: 'cle',
  production: true,
  apiURL: "https://cleevent.ecbee.net"
};
